import { render } from "./TableCol.vue?vue&type=template&id=4704a008"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__